import initAccordion from '../initAccordion';
import initSimpleParallax from '../parallax/initSimpleParallax';
import { parallaxHorizontalOptions, parallaxVerticalOptions } from '../parallax/parallax';

document.addEventListener('DOMContentLoaded', (e) => {
  initAccordion();

  const parallaxHorizontalCards = document.querySelectorAll('[data-parallax-horizontal-card]');
  const parallaxVerticalCards = document.querySelectorAll('[data-parallax-vertical-card]');

  initSimpleParallax(parallaxHorizontalCards, parallaxHorizontalOptions);
  initSimpleParallax(parallaxVerticalCards, parallaxVerticalOptions);
});
